import { PRECIP_BASE, tintOpacity } from "../../lib/timelineTint";

interface TintRampProps {
  label?: string;
}

export function TintRampSample({ label }: TintRampProps) {
  const steps = [10, 25, 45, 65, 85, 95];
  return (
    <div className="flex flex-col gap-1">
      {label ? <span className="text-[12px] text-on-surface-variant">{label}</span> : null}
      <div className="flex gap-1">
        {steps.map((pop) => (
          <div
            key={pop}
            className="h-3 w-6 rounded-sm"
            style={{ backgroundColor: PRECIP_BASE.rain, opacity: tintOpacity(pop) }}
            title={`${pop}%`}
          />
        ))}
      </div>
    </div>
  );
}

export function ThunderDotSample() {
  return <span className="inline-block h-[5px] w-[5px] rounded-full bg-weather-thunder-70" />;
}

export function ThunderLadderSample() {
  const bands = [
    { label: "15–29%", className: "bg-weather-thunder-low opacity-70", size: 3 },
    { label: "30–49%", className: "bg-weather-thunder-30", size: 4 },
    { label: "50–69%", className: "bg-weather-thunder-50", size: 4 },
    { label: "70–84%", className: "bg-weather-thunder-70", size: 5 },
    { label: "≥ 85%", className: "bg-weather-thunder-85", size: 5 },
  ] as const;

  return (
    <div className="flex flex-col gap-2">
      {bands.map((band) => (
        <div key={band.label} className="flex items-center gap-2">
          <span
            className={`inline-block rounded-full ${band.className}`}
            style={{ width: `${band.size}px`, height: `${band.size}px` }}
          />
          <span className="text-[12px] text-on-surface-variant">{band.label}</span>
        </div>
      ))}
    </div>
  );
}

export function WindSparklineSample() {
  return (
    <svg className="h-3 w-32" viewBox="0 0 18 12" preserveAspectRatio="none" aria-hidden>
      <polyline
        fill="none"
        points="0.5,10 4.5,8 8.5,4 12.5,3 16.5,6"
        stroke="var(--tc-color-on-surface-variant)"
        strokeOpacity={0.65}
        strokeWidth={1}
        vectorEffect="non-scaling-stroke"
      />
      <polyline
        fill="none"
        points="0.5,10 4.5,8 8.5,3 12.5,2 16.5,5"
        stroke="var(--color-weather-gust)"
        strokeDasharray="2 2"
        strokeOpacity={0.75}
        strokeWidth={1}
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

export function PrecipTrackSample({ color }: { color: string }) {
  return (
    <div className="flex h-2 w-24 gap-px">
      {[0.25, 0.45, 0.65, 0.85, 1].map((opacity, index) => (
        <div key={index} className="flex-1" style={{ backgroundColor: color, opacity }} />
      ))}
    </div>
  );
}
